<div class="tag-label alc-ellipsis">{{ group.name | uppercase }}</div>
<div class="tag-value-and-chevron">
  <div class="tag-value alc-ellipsis">{{ selectedTag?.name }}</div>
  <ion-icon name="chevron-down"></ion-icon>
</div>
